import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HomeReviews = () => {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    axios.get(`${API}/reviews/summary`).then(({ data }) => setReviews(data)).catch(() => {});
  }, []);

  if (!reviews || reviews.count === 0) return null;

  return (
    <section id="recensioni" className="relative py-20 sm:py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-12"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600 mb-4">
            La parola a chi l'ha provato
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0A192F]">
            Il matching funziona. <span className="text-[#10B981]">Da entrambe le parti.</span>
          </h2>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-5 py-2 text-sm font-bold text-[#0A192F]">
            <span className="text-[#10B981]">★ {reviews.avg}</span> · {reviews.count}{" "}
            {reviews.count === 1 ? "recensione verificata" : "recensioni verificate"}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {reviews.latest.slice(0, 3).map((rev, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-[1.75rem] bg-white border border-slate-200/80 p-7 shadow-[0_10px_30px_rgba(10,25,47,0.05)] hover:shadow-[0_20px_45px_rgba(10,25,47,0.09)] hover:-translate-y-1 transition-all duration-300"
              data-testid={`home-review-${i}`}
            >
              <Quote className="w-6 h-6 text-emerald-200 mb-4" />
              <div className="flex gap-0.5 mb-4">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} className={`w-4 h-4 ${n <= rev.rating ? "fill-[#10B981] text-[#10B981]" : "text-slate-200"}`} />
                ))}
              </div>
              <blockquote className="text-[15px] text-slate-600 leading-relaxed italic">“{rev.testo}”</blockquote>
              <figcaption className="mt-4">
                <p className="text-sm font-bold text-[#0A192F]">{rev.nome}</p>
                <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mt-0.5">{rev.ruolo}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
